import { W as WuiListItemHeader$1, d as defineCustomElement$1 } from './list-item-header.js';

const WuiListItemHeader = WuiListItemHeader$1;
const defineCustomElement = defineCustomElement$1;

export { WuiListItemHeader, defineCustomElement };

//# sourceMappingURL=wui-list-item-header.js.map